













import { defineComponent, computed } from '@vue/composition-api';

import getHandicraftSubGroups from '@/gql/getHandicraftSubGroups.gql';
import { useQuery, useResult } from '@vue/apollo-composable';

const CommonHandicraftSubGroupSelector = defineComponent({
  setup(props: any) {
    /* ==== Define creator group ==== */
    const { result: handicraftSubGroupResult, loading } = useQuery(getHandicraftSubGroups);
    const handicraftSubGroup = useResult(handicraftSubGroupResult, null, (data) => data.handicraftSubGroups);
    const computedHandicraftSubGroupId = computed(() => {
      const temp: string[] = [];
      if (!handicraftSubGroup.value) return [undefined];
      handicraftSubGroup.value.forEach((item: any) => {
        temp.push(item.id);
      });
      return temp;
    });
    const computedHandicraftSubGroupName = computed(() => {
      const temp: string[] = [];
      if (!handicraftSubGroup.value) return [undefined];
      handicraftSubGroup.value.forEach((item: any) => {
        temp.push(item.name);
      });
      return temp;
    });
    // const computedHandicraftSubGroupCode = computed(() => {
    //   const temp: string[] = [];
    //   if (!handicraftGroup.value) return [undefined];
    //   handicraftGroup.value.forEach((item: any) => {
    //     temp.push(item.code);
    //   });
    //   return temp;
    // });
    // ============================== //

    const _value = computed(() => props.value);

    return {
      loading,
      computedHandicraftSubGroupId,
      computedHandicraftSubGroupDisplay: computedHandicraftSubGroupName,
      _value,
    };
  },
  props: {
    label: {
      type: String,
      default() { return 'กลุ่มงานรอง'; },
    },
    value: {
      type: String,
      default() { return ''; },
    },
    // displayCode: {
    //   type: Boolean,
    //   default() { return false; },
    // },
  },
});

export default CommonHandicraftSubGroupSelector;
